import { render, staticRenderFns } from "./TakeExpressDelivery.vue?vue&type=template&id=3865a060&scoped=true"
import script from "./TakeExpressDelivery.vue?vue&type=script&lang=js"
export * from "./TakeExpressDelivery.vue?vue&type=script&lang=js"
import style0 from "./TakeExpressDelivery.vue?vue&type=style&index=0&id=3865a060&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3865a060",
  null
  
)

export default component.exports